import { Box } from "@material-ui/core";
import React from "react";

import type { FC, SVGAttributes } from "react";

export const LiveCommerceItemCounter: FC<{
  count: number;
  decrementNumber: () => void;
  incrementNumber: () => void;
}> = ({ count, decrementNumber, incrementNumber }) => {
  return (
    <Box
      display="inline-flex"
      alignItems="center"
      bgcolor={"#fff"}
      border={"1px solid #ccc"}
      borderRadius={4}
      overflow={"hidden"}
    >
      <Box
        onClick={decrementNumber}
        component={"button"}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
        width={"40px"}
        height={"40px"}
        padding={"8px"}
        bgcolor={"#fff"}
        border={"none"}
        style={{
          cursor: "pointer",
        }}
      >
        <DecrementIcon
          style={{
            width: "22px",
            height: "auto",
          }}
        />
      </Box>
      <Box
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
        minWidth={"40px"}
        height={"40px"}
        padding={"10px 8px 8px"}
      >
        {count}
      </Box>
      <Box
        onClick={incrementNumber}
        component={"button"}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
        width={"40px"}
        height={"40px"}
        padding={"8px"}
        bgcolor={"#fff"}
        border={"none"}
        style={{
          cursor: "pointer",
        }}
      >
        <IncrementIcon
          style={{
            width: "22px",
            height: "auto",
          }}
        />
      </Box>
    </Box>
  );
};

const DecrementIcon: FC<SVGAttributes<SVGElement>> = (props) => {
  return (
    <svg viewBox="0 0 24 24" {...props}>
      <path
        d="M18.75 12H5.25"
        stroke="black"
        strokeOpacity="0.92"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const IncrementIcon: FC<SVGAttributes<SVGElement>> = (props) => {
  return (
    <svg viewBox="0 0 24 24" {...props}>
      <path
        d="M12 5.25V18.75M18.75 12H5.25"
        stroke="black"
        strokeOpacity="0.92"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
